var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTeacherChooseRole24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-teacher-choose-role-24_svg__clip0_974_68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.81 8.45a.25.25 0 01-.14-.2.25.25 0 01.1-.25 4.5 4.5 0 10-5.54 0 .25.25 0 01.1.21.25.25 0 01-.14.2A6 6 0 000 13.75v3.5a1 1 0 001 1h1.12a.5.5 0 01.5.46l.38 4.6a.76.76 0 00.75.69h4.5a.76.76 0 00.75-.69l.38-4.6a.5.5 0 01.5-.46H11a1 1 0 001-1v-3.5a6 6 0 00-3.19-5.3zM3.6 3.82a.24.24 0 01.14-.17.28.28 0 01.22 0A5.92 5.92 0 007 4.5a6.67 6.67 0 001.19-.12.23.23 0 01.21 0 .25.25 0 01.09.2 2.5 2.5 0 11-5-.13 2.15 2.15 0 01.11-.63zM10 15.75a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5v-2A4 4 0 014.67 10a.25.25 0 01.22 0 .23.23 0 01.11.2v3.52a1 1 0 102 0v-3.49a.23.23 0 01.11-.2.251.251 0 01.22 0A4 4 0 0110 13.75v2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 0h-8.5a1 1 0 000 2H21a1 1 0 011 1v13a1 1 0 01-1 1h-6a1 1 0 000 2h6a3 3 0 003-3V3a3 3 0 00-3-3z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-teacher-choose-role-24_svg__clip0_974_68"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgIconTeacherChooseRole24;